import { useState, useEffect } from 'react';
import { AssetType } from 'src/types/assets';
import { useWebSockets } from 'src/contexts/webSocketsContext/websockets.context';

type useAssetModeDataArgumentsTypes = {
  asset: AssetType;
};

export function useAssetModeData({ asset }: useAssetModeDataArgumentsTypes) {
  const [assetMode, setAssetMode] = useState<string>('');

  const { assetModeMessages } = useWebSockets();

  const findAsset = assetModeMessages?.find((item: any) => item?.data?.assetId === asset?.id);

  useEffect(() => {
    if (!asset) {
      setAssetMode('');
      return;
    }

    const currentMode = findAsset?.data?.event?.currentMode;

    setAssetMode(currentMode?.label ?? '');
  }, [findAsset, asset]);

  return { assetMode };
}
